<template>
  <gh-date-picker v-if="!readonly" v-model="value" :validator="validator" :label="prop.text" :id="prop.value"
    :rules="rules" :text="prop.text">
  </gh-date-picker>
  <v-text-field v-else readonly v-model="value" :label="prop.text" :id="prop.value" :color="prop.color"></v-text-field>
</template>

<style scoped>

</style>

<script>
  import DateInput from "./dateInput.ts";
  export default DateInput;
</script>